import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { checkAuth } from '../redux/authenticator'
import { AuthService } from '../services/auth.service'

export const ProtectedRoute = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const isLogged = useAppSelector(state => state.authenticator.isLogged)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const session = await AuthService.getCurrentSession()
        if (session) {
          // Session exists, verify it's still valid
          await dispatch(checkAuth()).unwrap()
        }
      } catch (error) {
        // No valid session
      } finally {
        setIsChecking(false)
      }
    }

    verifyAuth()
  }, [dispatch])

  if (isChecking) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f5f5f5'
        }}>
        <CircularProgress />
      </Box>
    )
  }

  return isLogged ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />
}